import datepicker from 'js-datepicker';
import Inputmask from 'inputmask';

const fields = () => {
  $('input[data-mask]').each((i, el) => {
    const mask = new Inputmask($(el).data('mask'), {
      placeholder: ' ',
      clearMaskOnLostFocus: false
    });
    mask.mask(el);
  });

  $('.js-date-field').each((i, el) => {
    const lang = $(el).data('lang');
    const now = new Date();

    const opts = {
      onSelect: (instance) => {
        setTimeout(() => {
          instance.hide();
        }, 0);
      },
      formatter: (input, date) => {
        let month = date.getMonth() + 1;
        if (month < 10) month = `0${month}`;
        const value = `${date.getDate()}-${month}-${date.getFullYear()}`;
        $(input).val(value);
      },
      startDay: 1,
      minDate: now,
      disableYearOverlay: true,
      showAllDates: true,
      dateSelected: now
    };

    if (lang && typeof lang === 'object') {
      opts.customMonths = lang.months;
      opts.customDays = lang.days;
    }

    const picker = datepicker(el, opts);

    $(el).on('keydown', event => {
      event.preventDefault();
    });

    $(el).on('click', () => {
      picker.show();
    });

  });
};

export default fields;
